export default "__VITE_ASSET__C$m_Dtpk__"